module.exports = __webpack_public_path__ + "images/878515e3f5bcf1a88b3990104f37dca7.png";